<template>
  <section class="container">
    <div class="row">
      <div class="col-12">
        <h5>Parrainer un ami</h5>
        <p>
          Gagnez 10 € grâce à votre code de parrainage ! Partagez votre
          code à vos amis : à chaque souscription, votre filleul et
          vous-même serez crédités de 10 € sur votre cagnotte.
        </p>
      </div>
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4">
            <div class="row">
              <div class="col-12 col-lg-9 mx-auto">
                <h5 class="mb-3">
                  Votre message
                </h5>
                <v-input
                  input-id="message-sponsorship"
                  label="Accompagnez votre invitation d'un message"
                  module-name="sponsorship"
                  :input-validation="() => null"
                  getter-name="message"
                  placeholder="Bonjour Nicolas !"
                  path="message"
                  class="mb-4"
                />
                <v-loader
                  :disabled="message.length === 0"
                  title="Envoyer"
                  icon="fly-paper-white"
                  :next="pushNewSponsorship"
                  class="w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Textarea from '@/components/common/input/Textarea.vue';

export default {
  name: 'SponsorshipMessage',
  components: {
    'v-input': Textarea,
  },
  computed: {
    message() {
      return this.$store.getters['sponsorship/message'] || '';
    },
  },
  methods: {
    async pushNewSponsorship() {
      await this.$store.dispatch('sponsorship/pushNewSponsorship');
      return this.$router.push('/client/perks/sponsorship/confirmation');
    },
  },
};
</script>
